/**
 * Gets Search Params From URL
 * @returns {{}} object with params
 */
export const getSearchParamsFromURL = () => {
    const data = {};

    if (location.search) {
        const pair = location.search.substr(1).split('&');

        for (let i = 0; i < pair.length; i++) {
            const param = pair[i].split('=');
            data[param[0]] = param[1];
        }
    }

    return data;
};

/**
 * Gets all element of path after domain name
 * @returns [] Array of elements
 */
export const parseUrlBySlash = () => {
    const data = [];
    if (window.location) {
        const pair = location.pathname.split('/');
        for (let i = 0; i < pair.length; i++) {
            const param = pair[i];
            data[i] = param;
        }
    }
    return data;
};

/**
 * Gets current locale and context
 * @param data {Array} - array of elements of path
 * @returns String with current locale and context
 */
export const getLocale = data => {
    const indexOfTargetPageUri = 4; // index of target page always will be fourth after section, region and language ids
    const splicedArray = data.slice(0, indexOfTargetPageUri);
    const localeString = splicedArray.join('/');

    return localeString;
};

export const getPrependedUrlPath = (basePath = 'search') => {
    const splittedPathName = window.location.pathname.split('/');
    const indexOfArgument = splittedPathName.indexOf(basePath);
    const splicedArray = splittedPathName.slice(0, indexOfArgument);

    const convertedToStringUrl = splicedArray.join('/');
    const prependedUrl = `${convertedToStringUrl}/${basePath}`;

    return prependedUrl;
};

/**
 * Tries to retrieve URL part from current location for using with data-ajax-param attribute of a DOM node
 * @returns {string} - URL part
 */
export const tryGetAjaxParamUrlForCurrentLocation = () => {
    const defaultResult = null;
    const currentHref = window.location.href;
    const prependedUrlPath = getPrependedUrlPath('search');
    const parts = currentHref.split(prependedUrlPath);
    const result = parts.length === 2 ? parts[1] : defaultResult;
    return result || defaultResult;
};

/**
 * This function manages if className must be set to the element depending on shouldBePresented flag
 * @param element { Element } - DOM Element which may has passed className
 * @param className { String } - string representing class name which need to manage
 * @param shouldBePresented { Boolean } - if flag is true - class will be set, otherwise - removed
 */
export const manageElementClassByState = (element, className, shouldBePresented) =>
    !!shouldBePresented !== element.classList.contains(className) &&
    element.classList.toggle(className);

export const manageElementClassListByState = (element, classNameList = [], shouldBePresented) =>
    classNameList.forEach(className =>
        manageElementClassByState(element, className, shouldBePresented),
    );

const openClassName = 'open';

/**
 * If 'isOpen' state is true then 'open' class will be added to the DOM element
 * @param isOpen { Boolean } - boolean flag determining if DOM element should have 'open' class
 * @param element { Element } - DOM element
 */
export const setOpenState = (isOpen, element) =>
    manageElementClassByState(element, openClassName, isOpen);

/**
 * Checks if elementFrom has 'open' class and if so - adds this class to the 'elementTo' element too,
 * otherwise - remove this class from 'elementTo' element
 * @param elementFrom { Element } - source DOM element
 * @param elementTo { Element } - target DOM element
 */
export const syncOpenState = (elementFrom, elementTo) =>
    setOpenState(elementFrom.classList.contains(openClassName), elementTo);

/**
 * Adds event listener to the owner element with null checks
 * @param owner {Node} - target DOM element
 * @param type {String} - event type as a string
 * @param handlerFunction {Function | EventListener} - event handler function
 */
export const tryAddEventListener = (owner, type, handlerFunction) => {
    if (!owner || !owner.addEventListener || !type || !handlerFunction) return;
    owner.removeEventListener(type, handlerFunction);
    owner.addEventListener(type, handlerFunction);
};

export const tryGetTarget = (element, targetClass) => {
    let target = element;

    while (!target.classList.contains(targetClass)) {
        target = target.parentNode;
        if (target === document.body) return null;
    }
    return target;
};

export const tryGetAjaxParam = element => {
    if (!element || !element.dataset) return null;
    let { ajaxParam } = element.dataset;
    if (!ajaxParam) {
        const child = element.querySelector('[data-ajax-param]');
        if (child && child.dataset) {
            // eslint-disable-next-line prefer-destructuring
            ajaxParam = child.dataset.ajaxParam;
        }
    }
    return ajaxParam;
};

/**
 * I have no idea what's going on here
 */
export const handleCommaFormat = amount => {
    const delimiter = ',';
    let a = amount.split('.', 2);
    const d = a[1];
    let i = parseInt(a[0], 10);

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(i)) {
        return '';
    }

    let minus = '';

    if (i < 0) {
        minus = '-';
    }

    i = Math.abs(i);
    let n = i.toString();
    a = [];

    while (n.length > 3) {
        const nn = n.substr(n.length - 3);
        a.unshift(nn);
        n = n.substr(0, n.length - 3);
    }

    if (n.length > 0) {
        a.unshift(n);
    }

    n = a.join(delimiter);

    if (d) {
        if (d.length < 1) {
            amount = n;
        } else {
            amount = `${n}.${d}`;
        }
    } else {
        amount = n;
    }
    amount = minus + amount;

    return amount;
};

export const testForNumber = char => {
    const regexp = /[0-9]/;
    return regexp.test(char);
};
